import { Box } from "@mui/material";
import RoleShow from "./components/RoleShow";
import styles from "./style.module.css";
import { useState } from "react";
import AddNewRoleButton from "./components/AddNewRoleButton";
import AddRoleModal from "./components/AddRoleModal";
import { useSelector } from "react-redux";

const RolesList = () => {
  const roles = useSelector((state) => state.roles.value);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModal = async (state) => {
    setIsModalOpen?.(state);
  };

  const renderRoles = roles.map((role, index) => {
    return <RoleShow role={role} key={index} num={index + 1} />;
  });

  return (
    <Box className={styles.roles}>
      <AddRoleModal isModalOpen={isModalOpen} handleModal={handleModal} />
      {renderRoles}
      <AddNewRoleButton handleModal={handleModal} />
    </Box>
  );
};

export default RolesList;
